import type { LayoutLoad } from './$types';
import { PUBLIC_FINANCEFY_URL } from '$env/static/public';
import { Translator } from '$lib/translations/translations';
import __ from '$lib/stores/TranslationStore';

export const load = (async (event) => {
	let language: string;

	//Use to landing pages -
	if (event.url.searchParams.get('lang')) {
		language = event.url.searchParams.get('lang') ?? '';
		event.data.language = language;
	} else if (event.params.lang) {
		language = event.params.lang;
	} else {
		language = event.data.language ?? (event.url.host === PUBLIC_FINANCEFY_URL ? 'en' : 'pt');
	}

	const translator = new Translator(event.data.langMap);
	// Make translator globally available on sotore
	__.set((expression) => translator.translate(expression));

	event.data.embed = Boolean(event.params.embed);

	return event.data;
}) satisfies LayoutLoad;
